<template>
	<v-flex xs12 sm10 offset-sm1 md10 offset-md1 lg10 offset-lg1>
		<div class="text-xs-center">
			<v-chip
				color="rgba(10,10,10,0.9)"
				text-color="white"
				>{{ selectedFilters.dateFrom }} --- {{ selectedFilters.dateTill }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="country in selectedFilters.mandator"
				:data="country.text"
				:key="country.text"
				>{{ country.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.country"
				:data="item.name"
				:key="item.alpha_2"
				>{{ item.name }}
			</v-chip>
				<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="kantons in selectedFilters.kantons"
				:data="kantons.text"
				:key="kantons.text"
				>{{ kantons.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="status in selectedFilters.status"
				:data="status.text"
				:key="status.value"
				>{{ status.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.nationality"
				:data="item.text"
				:key="item.value"
				>{{ item.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.nationalityIso"
				:data="item.name"
				:key="item.alpha_2"
				>{{ item.name }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="serviceprovider in selectedFilters.serviceprovider"
				:data="serviceprovider.text"
				:key="serviceprovider.text"
				>{{ serviceprovider.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="taxexemption in selectedFilters.taxexemption"
				:data="taxexemption.text"
				:key="taxexemption.text"
				>{{ taxexemption.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.checkInDates"
				:data="item"
				:key="item"
				>{{txt.checkIn}}: {{ item }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.checkOutDates"
				:data="item"
				:key="item"
				>{{txt.checkOut}}: {{ item }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.arrivalBy"
				:data="item"
				:key="item.value"
				>{{txt.transport}}: {{ item.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.serviceproviderCity"
				:data="item"
				:key="item.value"
				>{{ item.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.serviceproviderAccommodationType"
				:data="item"
				:key="item.value"
				>{{ item.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.resellerPartner"
				:data="item"
				:key="item.value"
				>{{ item.text }}
			</v-chip>
			<v-chip
				color="rgba(10,10,10,0.3)"
				text-color="black"
				v-for="item in selectedFilters.resellerUser"
				:data="item"
				:key="item.value"
				>{{ item.text }}
			</v-chip>
		</div>
	</v-flex>
</template>

<script>
export default {
	name: 'RegistrationReportSelectedFilter',
	props: {
		selectedFilters: {
			type: Object,
		},
	},
	data() {
		return {
			selectedRegstatus: '',
			txt: {
				checkIn: 'Check-in',
				checkOut: 'Check-out',
				transport: 'Transport',
			},
		}
	},
}

</script>

<style scoped>
.text-xs-center {
  height: 45px;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
}

.v-chip{
  margin-left: 5px;
}

</style>>
